import React, {FC} from "react";
import {TranslationKeys} from "@/contexts/TranslationKeys.ts";
import Description from "@/components/description/Description.tsx";
import {useLocale} from "@/contexts/localeContext.tsx";

interface GroupDescriptionProps {
    onNext: () => void;
    onBack: () => void;
    title: string;
}

const GroupDescription: FC<GroupDescriptionProps> = ({onNext, onBack, title}) => {
    const {translate} = useLocale();

    return <div className="pt-3 pr-3 h-full relative">
        <div className="flex flex-col pr-3">
            <div className="pb-4">
                <Description title={translate.byKey(TranslationKeys.description)} isRequired={false} accessor={"idpGroupDescription"} height={"h-32"}/>
            </div>
        </div>
        <div className="flex justify-end w-full absolute bottom-0 pr-3 pb-3">
            <button
                className={`py-1 px-5 mt-3  secondary secondary-inverse mr-2 py-1 px-5`}
                type="button"
                onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            <button
                className={`py-1 px-5 mt-3 secondary text-white bg-portal-blue-primary-shade2`}
                type="button"
                onClick={onNext}>{translate.byKey(TranslationKeys.next)}</button>
        </div>
    </div>
};

export default GroupDescription;
